import { DataStore } from "aws-amplify/datastore";
import { Settings } from "../../models";
import { SettingsRepository } from "../interfaces";
import { SettingsRecord } from "../types";

export class DatastoreSettingsRepository implements SettingsRepository {
  async get(): Promise<SettingsRecord> {
    const all = await DataStore.query(Settings);
    const sorted = all.sort(
      (a, b) => new Date(a.createdAt ?? 0).getTime() - new Date(b.createdAt ?? 0).getTime()
    );
    if (sorted.length > 0) {
      return sorted[0] as unknown as SettingsRecord;
    }
    return {
      id: "new",
      invoicePrefix: "INV",
      invoiceNumber: 1,
      emailSettings: {
        subject: "Latest Invoice",
        defaultText: "Dear [client_name], \n Please find attached your latest invoice.",
      },
      emailTemplates: [
        {
          templateName: "void",
          includeAttachment: true,
          subject: "Invoice Voided",
          body: "Dear [client_name],\n The attached invoice [invoice_name] has been voided. Payment is no longer due.",
        },
      ],
    };
  }

  async save(settings: SettingsRecord): Promise<void> {
    if (settings.id === "new") {
      await DataStore.save(new Settings(settings as any));
    } else {
      const original = await DataStore.query(Settings, settings.id);
      if (!original) throw new Error("No existing settings found");
      await DataStore.save(Settings.copyOf(original, (draft) => { Object.assign(draft, settings); }));
    }
  }
}
